import { CommonModule } from '@angular/common';
import { Component, effect, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EditingService, Measurement, MeasurementType } from '@evident/ngx-media-viewer';
import { TranslateModule } from '@ngx-translate/core';
import { ConvertMeasure } from '../convert-measure.pipe';
import * as Measure from '../measurement.type';
import { ButtonComponent } from '@evc/web-components';
import { TenantConfigService } from '../../../../_services/http-api/tenant-config.service';
import { TenantConfig } from '../../../../app.constants';

@Component({
    selector: 'app-measurement-results',
    imports: [TranslateModule, CommonModule, ConvertMeasure, ButtonComponent],
    templateUrl: './measurement-results.component.html',
    styleUrl: './measurement-results.component.scss',
    standalone: true
})
export class MeasurementResultsComponent implements OnInit {
  public MeasurementType = MeasurementType;
  public measurements: Signal<Measurement[]> = signal([]);
  public temporaryMeasurements: Signal<Measurement | null> = signal(null);
  public unitSystem : WritableSignal<Measure.UnitSystem> = signal("Metric");
  public selectedMeasurement$ = toSignal(this.editingService.selectedMeasurement$);

  constructor(private editingService: EditingService, private tenantConfigService: TenantConfigService) {
    this.measurements = toSignal(this.editingService.measurements$);
    this.temporaryMeasurements = toSignal(this.editingService.temporaryMeasurement$);
  }

  ngOnInit() {
    this.setConfig();
  }

  public get precision() {
    return Measure.precision(this.unitSystem());
  }

  public getUnitLabel(unit: Measure.UnitType): string {
    return Measure.getUnitLabel(unit, this.unitSystem());
  }

  public changeUnitSystem() {
    this.unitSystem.update(unitSystem => Measure.isMetric(unitSystem) ? "Imperial": "Metric");
  }

  public getChangeUnitLabel() {
    return Measure.isMetric(this.unitSystem()) ? "Imperial" : "Metric";
  }

  public removeMeasure(measurement: Measurement) {
    this.editingService.deleteMeasurement(measurement);
  }

  public selectMeasurement(measurement: Measurement) {
    this.editingService.selectedMeasurement = measurement;
  }

  setConfig() {
      const unitSystemConfig = this.tenantConfigService.getConfigBykey(TenantConfig.DefaultUnitOfMeasurementResult.KEY);
      unitSystemConfig?.toLowerCase() === 'mm' ? this.unitSystem.set('Metric'):  this.unitSystem.set('Imperial');
  }
}
